// src/reducers/rpaAgentReducer.js
//
// Tracks the document/project context the RPA Agent chat is operating on.
// Populated by RpaDashboard when the user selects a document row.

const initialState = {
  selectedDocId:     null,
  selectedProjectId: null,
  selectedDocName:   null,
  selectedWorkflow:  null,
};

export const rpaAgentReducer = (state = initialState, action) => {
  switch (action.type) {

    // Dispatched by RpaDashboard when a doc row is clicked / View Results opened
    case 'SET_RPA_AGENT_CONTEXT':
      return {
        ...state,
        selectedDocId:     action.payload?.docId     ?? null,
        selectedProjectId: action.payload?.projectId ?? null,
        selectedDocName:   action.payload?.docName   ?? null,
        selectedWorkflow:  action.payload?.workflow  ?? null,
      };

    // Clear context (e.g. when navigating away from /rpa)
    case 'CLEAR_RPA_AGENT_CONTEXT':
      return initialState;

    default:
      return state;
  }
};